import clsx from "clsx";
import shape from "../../assets/img/shapes/parasuit-shape-01.webp";


const ParasuitShape02 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-parasuit-shape-02", props.className)}>
            <img src={shape} alt="rmdr-parasuit-shape-02" loading="lazy" width={68} height={94} />
        </div>
    )

}

export default ParasuitShape02;
